import { mapActions } from 'pinia';
import { useAlertStore } from '@/stores/alert';

export default {
    methods: {
        ...mapActions(useAlertStore, ['notifySuccess', 'notifyError']),
    },
};
